<template>
    <div :class="getCSSClass('schedule-mailer-container')">
        <div v-if="loadingMonths" v-html="loadingIndicator"></div>
        <template v-else>
            <div :class="getCSSClass('repository-manager-function-popup-header') + ' ' + getCSSClass('repository-manager-function-popup-blue-header')">
                <h2 :class="getCSSClass('repository-manager-function-popup-header-mainheader')">
                    <span v-html="translate('Havi próbarend kiküldése')"></span>
                    <button :class="getCSSClass('edit-form-form-close-button')"
                            v-on:click="emitAndResetComponent('editing-canceled')"
                            type="button"
                            v-html="icon('close')"
                            style="margin-left: auto"
                    ></button>

                </h2>
                <h3 :class="getCSSClass('repository-manager-function-popup-header-subheader')"
                    v-html="translate('A lista a próba beazonosításához szükséges minimális adatokat tartalmazza.')"></h3>
            </div>
            <div :class="getCSSClass('repository-manager-function-popup-row')">
                <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Hónap')"></label> </div>
                <div :class="getCSSClass('repository-manager-function-popup-column')">
                    <select v-model="month">
                        <option v-for="monthData in months"
                                v-html="monthData.label"
                                :value="monthData.value"></option>
                    </select>
                </div>
            </div>
            <div :class="getCSSClass('repository-manager-function-popup-row')">
                <div :class="getCSSClass('repository-manager-function-popup-column')">
                    <label v-html="translate('E-mail bevezető szöveg')"></label> </div>
                <div :class="getCSSClass('repository-manager-function-popup-column')">
                    <tiny-mce-wrapper v-model="mailBody"
                                      :config="tinymceConfig"
                                      :min-height="150"
                                      :class="getCSSClass('repository-manager-comment-editor')"
                                      style="min-height: 150px"></tiny-mce-wrapper>

                </div>
            </div>
            <div :class="getCSSClass('repository-manager-function-popup-row')">
                <div :class="getCSSClass('repository-manager-function-popup-column')">
                    <label v-html="translate('Címzettek')"></label> </div>
                <div :class="getCSSClass('repository-manager-function-popup-column')">
                    <div style="display: flex; flex-direction: column">
                        <label v-for="recipient in recipients" :class="getCSSClass('schedule-mailer-recipient')">
                            <input type="checkbox" v-model="recipient.send">
                            <span v-html="recipient.name+' ('+recipient.email+')'"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div :class="getCSSClass('repository-manager-function-popup-row')">
                <div v-if="loadingEvents" v-html="loadingIndicator"></div>
                <template v-else>
                    <div v-if="events.length == 0" v-html="translate('Nincs megjeleníthető elem')"></div>
                    <div v-if="events.length > 0" style="flex-grow: 1; overflow-y: auto">
                        <table :class="getCSSClass('schedule-mailer-event-list')" >
                            <tbody>
                                <tr v-for="event in events"
                                    :class="getCSSClass('schedule-mailer-event-list') +' ' + getCSSClass('schedule-mailer-event-list-'+event.highlight)"
                                    :style="{'background-color': event.highlight}"
                                >
                                    <td v-for="column in columns"
                                        :class="getCSSClass('schedule-mailer-event-column') + ' ' + getCSSClass('schedule-mailer-event-'+column.field+'-column')"                                        v-html="event[column.field]"
                                    >

                                    </td>
                                    <td>
                                        {{ translate('Kiemelés') }}&nbsp;&nbsp;
                                        <select v-model="event.highlight" style="padding-right: 2rem">
                                            <option v-for="highlightOption in highlightOptions"
                                                    v-html="highlightOption.label"
                                                    :value="highlightOption.value"></option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </div>
            <div :class="getCSSClass('repository-manager-function-popup-row')">
                <div :class="getCSSClass('repository-manager-function-popup-column')">
                    <label v-html="translate('Tesztküldéshez írja be a címzettet')"></label> </div>
                <div :class="getCSSClass('repository-manager-function-popup-column')">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                        <input type="text" v-model="testrecipient" style="max-width: 30rem; flex-grow: 1">
                        <button style="margin-left: 2rem"
                                type="button"
                                :class="getCSSClass('repository-manager-popup-save-button')"
                                v-on:click="sendMail(1)"
                                v-html="icon('mail')+translate('Tesztküldés')"
                        ></button>
                    </div>
                </div>
            </div>

        </template>
        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
            <button :class="getCSSClass('repository-manager-popup-save-button')"
                    v-on:click="sendMail(0)"
            ><span v-html="icon('mail')" class="mr-2"></span><span v-html="translate('Küldés')"></span>
            </button>
            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                    v-on:click="emitAndResetComponent('editing-canceled')"
            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
            </button>
        </div>

    </div>
</template>

<script>
    import {editformReplacementMixin} from "./mixins/editformReplacementMixin";

    export default {
        mixins: [editformReplacementMixin],
        props: {
            operationsUrl: {type: String},
        },
        data: function () {
            return {
                testrecipient: '',
                actualDataUrl: '',
                actualSaveUrl: '',
                month: -1,
                months: [],
                events: [],
                columns: [],
                highlightOptions: [],
                mailBody: '',
                loadingMonths: true,
                loadingEvents: false,
                tinymceConfig: {
                    toolbar: [
                        'bold italic',
                    ],
                    menubar: '',
                    content_css: '/css/app.css',
                    content_style: 'p {line-height: 1.5 !important}'
                        + '.mce-content-body {padding: .5rem}'
                },
                recipients: [],

            }
        },
        mounted() {
            let pieces = this.dataUrl.split('?');
            this.actualDataUrl = pieces[0];
            pieces = this.saveUrl.split('?');
            this.actualSaveUrl = pieces[0];
            this.fetchBasedata();
        },
        methods: {
            sendMail: function(test = 0) {
                window.axios.post(this.actualSaveUrl, {
                    operation: 'sendMail',
                    test: test,
                    mailBody: this.mailBody,
                    month: this.month,
                    testrecipient: this.testrecipient,
                    recipients: this.recipients,
                    events: this.events.map((event) => {return {id: event.id, highlight: event.highlight}})
                }).then((response) => {
                    this.$emit('submit-success', {message: response.data});
                }).catch((error) => {
                    if (error.response.data.errors) {
                        if (error.response.data.errors) {
                            if (error.response.data.errors.testrecipient) {
                                alert(error.response.data.errors.testrecipient[0]);
                                return;
                            }
                        }
                        alert(error.response.data.message);
                        return;
                    }
                    alert(error);
                })
            },
            fetchBasedata: function() {
                window.axios.get(this.actualDataUrl, {params: {operation: 'fetchMailerBasedata'}})
                    .then((response) => {
                        this.months = response.data.months;
                        this.columns = response.data.columns;
                        this.highlightOptions = response.data.highlightOptions;
                        this.mailBody = response.data.body;
                        this.recipients = response.data.recipients;
                        this.loadingMonths = false;
                        if (this.months.length > 0) {
                            this.month = this.months[0].value;
                        }
                    })
            },
            fetchEvents: function() {
                this.loadingEvents = true;
                window.axios.get(this.actualDataUrl, {params: {operation: 'fetchMailerEvents', month: this.month}})
                    .then((response) => {
                        this.events = response.data.events;
                        this.loadingEvents = false;
                    })
            }

        },
        computed: {},
        watch: {
            month: function() {
                this.fetchEvents();
            }
        }

    }
</script>
